angular.module('zc.core')
  .filter('unique', unique);

unique.$inject = [];
function unique() {
  return function(arr) {
    return _.uniq(arr);
  };
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/unique_array.js